<template>
  <el-select
    v-model="val"
    :size='size'
    :style='cssStyle'
    :disabled='disabled'
    :filterable="filterable"
    :clearable="clearable"
    remote
    reserve-keyword
    :placeholder="placeholder"
    :remote-method="search"
    :loading="loading"
    :allow-create="allowCreate"
    @change="change" @clear="change">
    <el-option
      v-for="item in items"
      :key="item[valueAttr]"
      :label="item[labelAttr]"
      :value="item[valueAttr]">
    </el-option>
  </el-select>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    size: {
      default: "mini"
    },
    cssStyle: {
      default: "width: 100%"
    },
    filterable: {
      default: true
    },
    clearable: {
      default: true
    },
    disabled: {
      default: false
    },
    placeholder: {
      default: ''
    },
    labelAttr: {
      default: "name"
    },
    valueAttr: {
      default: "id"
    },
    url: {
      default: "/client/dict"
    },
    allowCreate: {
      default: false
    },
    value: {},
    options: {}
  },
  data() {
    return {
      val: this.value,
      loading: false,
      items: this.options || []
    }
  },
  watch: {
    value: function(value) {
      this.val = value;
    },
    options: function(value) {
      this.items = value;
    }
  },
  methods: {
    change(val) {
      this.$emit('change', val);
    },
    search(keywords) {
      if(keywords) {
        keywords = keywords.toString().trim();
        if (keywords !== '') {
          this.loading = true;
          setTimeout(() => {
            this.post(this.url, {
              name: keywords
            }).then(resp => {
              this.loading = false;
              if (resp) {
                if (resp.data.success) {
                  this.items = resp.data.rows;
                  this.$emit('optionsChange', this.items);
                }
              }
            });
          }, 200);
        } else {
          this.items = [];
        }
      }
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cx/cxSearchSelect.vue